import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var seriesNavigationIcon = /*#__PURE__*/React.createElement("svg", {
  height: "14",
  width: "12",
  viewBox: "0 0 12 14",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "m9.333 6.93-8.8 6.93V0zm0-6.93H12v13.86H9.333z",
  fill: "currentColor"
}));

export { seriesNavigationIcon as default };
//# sourceMappingURL=seriesNavigationIcon.js.map
